/** * * Asynchronously loads the component for
SwapData
* */ import { lazyLoad } from "utils/loadable";
export const SwapData = lazyLoad(
  () => import("./index"),
  (module) => module.SwapData
);
